import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IonInfiniteScroll, ModalController} from '@ionic/angular';
import { GlobalService } from './../../../../config/services/global.service';
import { SelTipoPago } from '../../../../models/global.models';

@Component({
    selector: 'app-modal-tipo-pago',
    templateUrl: './modal-tipo-pago.component.html',
    styleUrls: ['./modal-tipo-pago.component.scss'],
})
export class ModalTipoPagoComponent implements OnInit {
    @ViewChild('tipoPagoSearchBar', null)tipoPagoSearchBar;
    
    @Input() select: string;
    @Input() tipo: string;

    public tipoPagoList:any; //SelTipoPago;
	  //public tipoPagoSearch: string  = '';
	  public loadTipoPago:    boolean = true;
    public loadTipoPagoIni: boolean = false;
    public showSearch:    boolean = false;
    public from: any;
    public itemSelect = [];

  	constructor( 
  		private globalService: GlobalService,
  		private router: Router,
  		public  modalController: ModalController
  	) {
  		this.tipoPagoList = {list: [], page: 0, pages: 0, iTotal: 0, search: ''}
  	}

  	ngOnInit() {
  		if(this.globalService.selects.tipoPago.length <= 0){
        	this.list('ini', null, 'Cargando...');
  		}else{
  			this.tipoPagoList.list = this.globalService.selects.tipoPago;
  		}
        this.focusSearch();
  	}
    
    focusSearch() {
        setTimeout(() =>{
        	this.tipoPagoSearchBar.setFocus();
        },400);
    }

  	async list(from, ev, loadinSMS) {
  		const token       = await this.globalService.getToken();
        const entidad:any = await this.globalService.entidadDefault();

        this.tipoPagoList.page      = this.tipoPagoList.page+1;
        let params                 = {};
            params['take']         = 500;
            params['page']         = this.tipoPagoList.page;
            params['search']       = this.tipoPagoList.search;
            params['appID']        = this.globalService.appID;
            params['sedeID']       = entidad.sedeID;
            params['tipoPagoID']    = null;
            params['clase']        = 'factura';
            params['cont']         = 1; //ingreso
        this.loadTipoPago = true;
        this.globalService.requestPost('global/tipoPago', params, 'jwt', token).subscribe(
            data => {
                if(data.validation == 'ok'){
                    let disabled = true;
                    if(data.list.length > 0){ 
                    	this.globalService.selects.tipoPago = data.list;
                        this.tipoPagoList.list = data.list;
                        disabled = false;
                    }
                    this.loadTipoPago    = false;
                    this.loadTipoPagoIni = true;
                    if(this.showSearch){
                    	this.focusSearch();
                    }
                }else{
                    this.globalService.failRequestHttp(data);
                }
            },
            error => {
                this.globalService.errorRequestHttp(error)
            }
        );
  	}

  	async tipoPagoSelect(item, ev) {
        if(this.select == 'single') {
            this.modalController.dismiss({
                'tipoPagoInfo': item
            });
        }else if(this.select == 'singleMultiple') {
            this.itemSelect.push(item);
            this.modalController.dismiss({
                'tipoPagoInfo': item
            });
        }
    }

  	async dismissModal(ev) {
        this.modalController.dismiss({
            'tipoPagoInfo': null
        })
    }
}



